export interface DraggableNode {
  id?: number
  isNew?: boolean
  isUpdated?: boolean
  state: any
  children?: DraggableNode[]
}
export const toDraggableNodes = (
  values: any[],
  childrenKey = 'children',
  idKey = 'id',
): DraggableNode[] =>
  values.map((value) => {
    const id = value[idKey] || Math.floor(Math.random() * 100000)
    const children = value[childrenKey] || []

    return {
      id,
      state: value,
      children: toDraggableNodes(children, childrenKey, idKey),
    }
  })

export const fromDraggableNodes = (
  nodes: DraggableNode[],
  childrenKey = 'children',
  customMapFn: (v) => any = (v) => v,
) =>
  nodes
    .map((node, i) => ({
      ...(node.state || {}),
      id: node.state?.id,
      sortOrder: i,
      [childrenKey]: fromDraggableNodes(
        node.children || [],
        childrenKey,
        customMapFn,
      ),
    }))
    .map(customMapFn)
